<template>
  <div id="instructionsView">
    <div v-if="$route.name === 'instructions'">
      <b-col lg="8" style="padding-left: 0px;">
        <h1>{{ $t('privatePage.instructions_header') }}</h1>
        <instructions-table :instructions="instructions" :allowEdit="true" v-on:beforeEditInstruction="beforeEditInstruction"></instructions-table>

        <b-button @click.stop="addInstruction" class="btn-secondary mt-2">
          {{ $t('privatePage.instruction_add_header') }}
        </b-button>
      </b-col>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import instructionsTable from '../../components/instructions/instructionstable'

export default {
  components: {
    instructionsTable
  },
  computed: {
    ...mapGetters('instructionsModule', ['instructions']),
    ...mapGetters(['selectedCulture'])
  },
  methods: {
    ...mapActions('instructionsModule', [
      'selectCurrentInstruction',
      'getInstruction',
      'getAllInstructions'
    ]),
    addInstruction: function() {
      this.selectCurrentInstruction({
        id: '',
        name: '',
        questionFormatId: 1,
        isStandardInstruction: false,
        translations: [],
        pages: []
      })
      this.$router.push({ path: '/private/instructions/instruction' })
    },
    beforeEditInstruction: function(instruction) {
      this.getInstruction({
        instructionId: instruction.id,
        languageId: this.selectedCulture.languageId
      }).then(() => {
        this.$router.push({ path: '/private/instructions/instruction' })
      })
    }
  },
  created() {
    this.getAllInstructions()
  }
}
</script>
